export const ENTRY_METHOD = {
  FREEFORM: 'F',
  TEMPLATE: 'T'
};

export const PURPOSE_OF_WIRE = {
  DISABLED: 'D',
  OPTIONAL: 'O',
  MANDATORY: 'M'
};

export const PAYMENT_METHOD = {
  DOMESTIC: 'domestic',
  INTERNATIONAL: 'international'
} as const;

const USD_EQUIVALENT = 'D';
const FOREIGN_CURRENCY = 'C';

export type AmountTypes = typeof USD_EQUIVALENT | typeof FOREIGN_CURRENCY;

export const AMOUNT_TYPE: { [key: string]: AmountTypes } = {
  USD_EQUIVALENT,
  FOREIGN_CURRENCY
};

export const CURRENCY_FORMAT = '0,00.00';
export const EXCHANGERATE_CURRENCY_FORMAT = '0,00.00[00000]';

export const ACTION = {
  DEFAULT: 'default'
};

export const ACCORDIONS = {
  INTERMEDIARY_BANK: 'intermediaryBank',
  ORIGINATOR_TO_BENEFICIARY_INFO: 'originatorToBeneficiaryInfo',
  BANK_TO_BANK: 'bankToBankInfo'
};

export const SERVICE_MESSAGE_TYPES = {
  INIT_PAY_NON_FX: 'InitPayNFX',
  INIT_PAY_FX: 'InitPayFX',
  INIT_PAY_DOM: 'InitPayDomWire'
} as const;

export const IBAN_OPTIONS = {
  IBAN: 'iban',
  OTHER: 'other'
};

export const IBAN_MAX_CHARACTER = 34;
